/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_MonthInputs */

const en_platform_view_month = /** @type {(inputs: Platform_View_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const pl_platform_view_month = /** @type {(inputs: Platform_View_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesiąc`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Platform_View_MonthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_month = /** @type {((inputs?: Platform_View_MonthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_MonthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_month(inputs)
	return en_platform_view_month(inputs)
});